/* Custom Theme JS — insert any custom theme js here... */

/* Sticky Add To Cart Bar: mirrors the native buy button once it scrolls out
   of view, and delegates the add back to it. */

(function () {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  var PRODUCT_BTN = 'product-form button[name="add"]';
  var PICKERS = 'variant-selects, variant-radios, variant-swatches, variant-mixed-inputs';

  // Theme translations when available, else the English strings.
  var hasLocalize = !!(window.theme && typeof window.theme.localize === 'function');
  function t(key, fallback) {
    try {
      var s = hasLocalize && window.theme.localize(key);
      return (typeof s === 'string' && s.trim()) ? s.trim() : fallback;
    } catch (e) { return fallback; }
  }

  function initStickyATC() {
    var nativeBtn = document.querySelector(PRODUCT_BTN);
    if (!nativeBtn) return;

    var TXT_ADD = t('ADD_TO_CART', 'Add to Cart');
    var TXT_SOLD_OUT = t('SOLD_OUT', 'Sold Out');
    var TXT_ADDING = 'Adding...';

    var btnStyles = window.getComputedStyle(nativeBtn);
    var btnBg = btnStyles.backgroundColor || '#111111';
    var btnRadius = btnStyles.borderRadius || '4px';

    var style = document.createElement('style');
    style.textContent = [
      '.sticky-atc-bar{position:fixed;bottom:0;left:0;right:0;z-index:9999;',
      'background:' + btnBg + ';padding:12px 20px;display:flex;align-items:center;',
      'justify-content:space-between;gap:16px;box-shadow:0 -4px 16px rgba(0,0,0,.15);',
      'transform:translateY(100%);transition:transform .3s ease}',
      '.sticky-atc-bar.is-visible{transform:translateY(0)}',
      '.sticky-atc-bar.is-hidden-by-modal{transform:translateY(100%)!important}',
      '.sticky-atc-bar__info{flex:1;min-width:0;overflow:hidden;padding-left:64px}',
      '.sticky-atc-bar__title{font-size:.75rem;font-weight:400;color:#000000;white-space:nowrap;',
      'overflow:hidden;text-overflow:ellipsis;margin:0 0 1px;opacity:.8}',
      '.sticky-atc-bar__variant{font-size:.72rem;color:#000000;opacity:.65;margin:0 0 2px;',
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.sticky-atc-bar__price{font-size:1.1rem;font-weight:700;color:#000000;margin:0;line-height:1.2}',
      '.sticky-atc-bar__actions{display:flex;align-items:center;gap:10px;flex-shrink:0}',
      '.sticky-atc-bar__btn{display:inline-flex;align-items:center;justify-content:center;',
      'padding:10px 24px;background:#ffffff;color:#000000;border:none;',
      'border-radius:' + btnRadius + ';font-size:.82rem;font-weight:700;cursor:pointer;',
      'white-space:nowrap;transition:opacity .2s ease;letter-spacing:.04em;',
      'text-transform:uppercase;font-family:var(--font--button,inherit)}',
      '.sticky-atc-bar__btn:hover{opacity:.85}',
      '.sticky-atc-bar__btn:disabled,.sticky-atc-bar__btn.is-loading{opacity:.45;cursor:not-allowed;pointer-events:none}',
      '.sticky-atc-bar__feedback{font-size:.72rem;color:#000000;opacity:.85;min-width:50px;text-align:center}',
      '@media(max-width:47.9275em){',
      '.sticky-atc-bar{padding:10px 14px;align-items:center}',
      '.sticky-atc-bar__info{padding-left:56px}',
      '.sticky-atc-bar__variant{white-space:normal;overflow:visible;text-overflow:unset}',
      '.sticky-atc-bar__price{font-size:.95rem}',
      '.sticky-atc-bar__btn{padding:9px 16px;font-size:.78rem}}'
    ].join('');
    document.head.appendChild(style);

    // Variant reads stay scoped to the main product section so quick shop
    // modals for other products cannot pollute the bar.
    var productSection = document.querySelector('.product-single, product-single');

    var productTitle = (function () {
      var el = productSection && productSection.querySelector('h1, .product-single__title');
      if (el) return el.textContent.trim();
      return document.title.split(' – ')[0].split(' | ')[0].trim();
    })();

    function getPrice() {
      var scope = productSection || document;
      var saleEl = scope.querySelector('.price__number--sale .money, .price__current--sale .money');
      if (saleEl) return saleEl.textContent.trim();
      var el = scope.querySelector('.price__text .money, .price .money');
      return el ? el.textContent.trim() : '';
    }

    function getVariantLabel() {
      var scope = productSection || document;
      var radios = scope.querySelectorAll('input[type="radio"]:checked');
      if (!radios.length) return '';

      var options = [];
      radios.forEach(function (r) {
        if (r.closest('quick-shop, .quick-shop, [data-quick-shop]')) return;
        var id = r.id || '';
        if (!id) return;
        var lbl = document.querySelector('label[for="' + id + '"]');
        var val = lbl ? lbl.textContent.trim() : r.value;
        if (!val) return;
        var match = id.match(/^option-(\d+)-/);
        options.push({ sortKey: match ? parseInt(match[1], 10) : 999, val: val });
      });

      if (!options.length) {
        var parts = [];
        scope.querySelectorAll('select[name="options[]"], .product-form select').forEach(function (sel) {
          if (sel.value) parts.push(sel.options[sel.selectedIndex].text.trim());
        });
        return parts.length ? parts.join(' / ') : '';
      }

      options.sort(function (a, b) { return a.sortKey - b.sortKey; });
      return options.map(function (o) { return o.val; }).join(' / ');
    }

    function isSoldOut() {
      return nativeBtn.disabled ||
        nativeBtn.getAttribute('aria-disabled') === 'true' ||
        /sold.?out|unavailable/i.test(nativeBtn.textContent);
    }

    var bar = document.createElement('div');
    bar.className = 'sticky-atc-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', hasLocalize ? TXT_ADD : 'Sticky add to cart');
    // Off-screen at rest: inert keeps it out of the tab order.
    bar.setAttribute('inert', '');
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="sticky-atc-bar__info">' +
        '<p class="sticky-atc-bar__title"></p>' +
        '<p class="sticky-atc-bar__variant"></p>' +
        '<p class="sticky-atc-bar__price"></p>' +
      '</div>' +
      '<div class="sticky-atc-bar__actions">' +
        '<span class="sticky-atc-bar__feedback" aria-hidden="true"></span>' +
        '<span class="visually-hidden" role="status" aria-live="polite"></span>' +
        '<button class="sticky-atc-bar__btn" type="button"></button>' +
      '</div>';
    document.body.appendChild(bar);

    var stickyBtn = bar.querySelector('.sticky-atc-bar__btn');
    var variantEl = bar.querySelector('.sticky-atc-bar__variant');
    var priceEl = bar.querySelector('.sticky-atc-bar__price');
    var feedbackEl = bar.querySelector('.sticky-atc-bar__feedback');
    var statusEl = bar.querySelector('[role="status"]');

    bar.querySelector('.sticky-atc-bar__title').textContent = productTitle;
    stickyBtn.textContent = TXT_ADD;

    // Visible feedback text is mirrored into the role="status" live region.
    function setFeedback(msg) {
      feedbackEl.textContent = msg;
      statusEl.textContent = msg;
    }

    function updateInfo() {
      // Skip while a drawer is open — avoids stale quick-shop variant reads.
      if (document.body.classList.contains('u-scroll-disabled')) return;
      priceEl.textContent = getPrice();
      var variant = getVariantLabel();
      variantEl.textContent = variant;
      variantEl.style.display = variant ? '' : 'none';
    }
    updateInfo();

    var isAdding = false;
    function updateBtnState() {
      if (isAdding) return;
      stickyBtn.disabled = isSoldOut();
      stickyBtn.textContent = stickyBtn.disabled ? TXT_SOLD_OUT : TXT_ADD;
    }
    updateBtnState();

    /* Visibility: inert state, body padding, transient will-change */

    var scrolledPast = false;
    var modalOpen = false;
    var shown = false;
    var basePadding = document.body.style.paddingBottom;
    var wcTimer = null;

    function updateBodyPadding() {
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
    }

    function syncVisibility() {
      var visible = scrolledPast && !modalOpen;
      if (visible === shown) return;
      shown = visible;
      // will-change only for the length of the transition, never permanently.
      bar.style.willChange = 'transform';
      if (wcTimer) clearTimeout(wcTimer);
      wcTimer = setTimeout(function () { bar.style.willChange = ''; }, 400);
      if (visible) {
        bar.removeAttribute('inert');
        bar.removeAttribute('aria-hidden');
        updateBodyPadding();
        window.addEventListener('resize', updateBodyPadding);
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
        window.removeEventListener('resize', updateBodyPadding);
        document.body.style.paddingBottom = basePadding;
      }
    }

    // Venue adds 'u-scroll-disabled' to <body> while any drawer/modal is open.
    function updateModalVisibility() {
      modalOpen = document.body.classList.contains('u-scroll-disabled');
      bar.classList.toggle('is-hidden-by-modal', modalOpen);
      if (!modalOpen) {
        updateInfo();
        updateBtnState();
      }
      syncVisibility();
    }
    new MutationObserver(updateModalVisibility)
      .observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // The theme fires 'on:variant:change' on the picker element once price and
    // buy button have re-rendered — cheaper than observing the whole section
    // (Swiper rewrites slide classes every frame).
    (productSection || document).querySelectorAll(PICKERS).forEach(function (p) {
      p.addEventListener('on:variant:change', function () {
        updateInfo();
        updateBtnState();
      });
    });

    // Availability can also be toggled straight on the buy button.
    new MutationObserver(function () { updateBtnState(); })
      .observe(nativeBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        scrolledPast = !entry.isIntersecting;
        bar.classList.toggle('is-visible', scrolledPast);
        syncVisibility();
      });
    }, { threshold: 0.5 }).observe(nativeBtn);

    /* Add to cart — delegates to the native button */

    function finishAdding(clearLoading) {
      isAdding = false;
      if (clearLoading) stickyBtn.classList.remove('is-loading');
      stickyBtn.disabled = false;
      updateBtnState();
    }

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled || isAdding) return;
      isAdding = true;
      // disabled as well as pointer-events:none, so keyboard Enter/Space
      // cannot fire a second add while the request is in flight.
      stickyBtn.disabled = true;
      stickyBtn.classList.add('is-loading');
      stickyBtn.textContent = TXT_ADDING;
      setFeedback('');
      statusEl.textContent = TXT_ADDING;
      nativeBtn.click();

      function cleanup() {
        document.removeEventListener('on:cart:loaded', onCartLoaded);
        document.removeEventListener('on:cart:failed', onCartFailed);
      }
      function onCartLoaded(e) {
        if (e.detail && e.detail.type === 'ADD') {
          cleanup();
          // Stays disabled for the 2s "Added!" window, as is-loading used to.
          stickyBtn.textContent = 'Added!';
          statusEl.textContent = 'Added!';
          setTimeout(function () { finishAdding(true); }, 2000);
        }
      }
      function onCartFailed(e) {
        if (e.detail && e.detail.type === 'ADD') {
          cleanup();
          finishAdding(true);
          setFeedback((e.detail.error && e.detail.error.message) || 'Error');
          setTimeout(function () { setFeedback(''); }, 3000);
        }
      }
      document.addEventListener('on:cart:loaded', onCartLoaded);
      document.addEventListener('on:cart:failed', onCartFailed);
      setTimeout(function () {
        cleanup();
        finishAdding(stickyBtn.textContent === TXT_ADDING);
      }, 6000);
    });
  }

  var bodyObserver = null;
  var initTimer = null;

  function stopWaiting() {
    if (bodyObserver) { bodyObserver.disconnect(); bodyObserver = null; }
    if (initTimer) { clearTimeout(initTimer); initTimer = null; }
  }

  function tryInit() {
    if (!document.querySelector(PRODUCT_BTN)) return false;
    stopWaiting();
    initStickyATC();
    return true;
  }

  // No polling: init as soon as the product form exists, else watch for it.
  function start() {
    if (tryInit()) return;
    bodyObserver = new MutationObserver(tryInit);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    initTimer = setTimeout(stopWaiting, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

})();
